export default (riskFactors, id) => {
	const {itRiskFactors, ...rest} = riskFactors;

	return {
		...rest,
		itRiskFactors: itRiskFactors.map((item) => {
			if (item.itRiskFactorId === id) {
				const {rationale, rationaleTypeId, ...rest} = item;
				return {
					...rest,
					isRejected: false,
					isRationaleEmpty: true
				};
			}
			return item;
		})
	};
};